import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { reduxForm, change } from 'redux-form';
import _ from 'lodash';
import { PAYROLL_FB_DATA_FORM } from 'src/constants/FormNames';
import { DateField, RadioField, SelectField } from 'src/jbc-front/components/Form';
import Button from 'jbc-front/components/Button';
import CommonModal from 'jbc-front/components/CommonModal';
import FbDataBankSelect from 'src/components/FbDataBankSelect';
import { ErrorsSection } from 'src/components';
import { FormSubmitBtn } from 'src/buttons';
import { useTranslation } from 'react-i18next';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { FB_DATA_OPTIONS, HDBANK_ACCOUNT_TYPES } from 'src/constants/Options';
import styles from './PayrollFBDataModal.scss';

const PayrollFBDataInsideForm = ({
  errors,
  submitting,
  pristine,
  submit,
  isOpen,
  hideModal,
  paymentRange,
  onModalHide,
  offices,
  clearFBDataService,
  fbDataBankOptions
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const yearMonth = _.get(paymentRange, 'yearMonth', '_').split('_');
  const header = `${t('features.EmployeePays.components.PayrollFBDataModal.Salary_transfer_data_export')}  ＜${yearMonth[0]}/${yearMonth[1]} ${t(
    'features.EmployeePays.components.PayrollFBDataModal.payment'
  )}＞`;
  const [office, setOffice] = useState();
  const [useBank, setBank] = useState();
  const [useService, setService] = useState();
  const [useIcashType, setIcashType] = useState();
  const HDBANK = 'hdbank';
  const singleBankValue = fbDataBankOptions?.length === 1 ? fbDataBankOptions[0].value : null;

  const selectExport = (e, newValue) => {
    newValue == 'select_branch' ? setOffice('select_branch') : setOffice(null);
  };

  const selectBank = (e, newValue) => {
    newValue ? setBank(newValue) : setBank(null);
  }

  const selectService = (e, newValue) => {
    newValue ? setService(newValue) : setService(null);
  }

  const selectIcashType = (e, newValue) => {
    newValue ? setIcashType(newValue) : setIcashType(null);
  }

  useEffect(
    () => {
      clearFBDataService();
      selectService();
      selectIcashType();
    },
    [useBank]
  );

  useEffect(
    () => {
      if (singleBankValue) {
        dispatch(change(PAYROLL_FB_DATA_FORM, 'bankSelect', singleBankValue));
        setBank(singleBankValue);
      }
    },
    [singleBankValue, dispatch]
  );
  
  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal, onModalHide }}>
      <CommonModal.Header hideModal={hideModal}>{header}</CommonModal.Header>
      <CommonModal.Body>
        <form className={styles.form}>
          <ErrorsSection errors={errors} />

          <p className="u-mb40">{t('features.EmployeePays.components.PayrollFBDataModal.Can_export_FirmBanking_data_for_transfer_via_internet_banking')}</p>

          <RadioField
            required
            name="exportType"
            label={t('features.EmployeePays.components.ExportPndModal.export_method')}
            options={FB_DATA_OPTIONS}
            onChange={selectExport}
          />

          {office == 'select_branch' &&
            <SelectField
              required
              label={t('features.EmployeePays.components.PayrollFBDataModal.office_name')}
              name="clientBranchId"
              options={offices}
              placeholder={t('features.EmployeePays.components.PayrollFBDataModal.please_select')}
            />
          }
    
          <div className={styles.wrap}>
            <FbDataBankSelect
              useBank={useBank}
              useService={useService}
              useIcashType={useIcashType}
              selectBank={selectBank}
              selectService={selectService}
              selectIcashType={selectIcashType}
              bankOptions={fbDataBankOptions}
            />
          </div>

          {useBank === HDBANK && (
            <RadioField
              required
              name="accountType"
              label={t('features.EmployeePays.components.PayrollFBDataModal.account_type')}
              options={HDBANK_ACCOUNT_TYPES}
            />
          )}

          <ul className={styles.notes}>
            <li>※ {t('features.EmployeeBonus.components.DownloadBonusFbModal.cannot_export_data_of_employees_whose_bank_account_information_is_not_registered')}</li>
            <li>※ {t('features.EmployeeBonus.components.DownloadBonusFbModal.cannot_export_data_of_employees_whose_transfer_amount_is_less_than_0')}</li>
          </ul>
        </form>
      </CommonModal.Body>
      <CommonModal.Footer>
        <Button onClick={hideModal} className="u-mr20">
          {t('components.BonusFormModal.Cancel')}
        </Button>
        <FormSubmitBtn text={t('features.EmployeeBonus.components.DownloadBonusFbModal.export')} {...{ submitting, pristine, submit }} />
      </CommonModal.Footer>
    </CommonModal>
  );
};

const PayrollFBDataForm = reduxForm({
  form: PAYROLL_FB_DATA_FORM,
  enableReinitialize: true
})(PayrollFBDataInsideForm);

const FbDataModal = ({ paymentRange, errors, onModalHide, handleSubmit, isOpen, hideModal, offices, clearFBDataService, fbDataBankOptions }) => (
  <PayrollFBDataForm
    isOpen={isOpen}
    hideModal={hideModal}
    onSubmit={values => handleSubmit(values, paymentRange)}
    paymentRange={paymentRange}
    errors={errors}
    onModalHide={onModalHide}
    offices={offices}
    clearFBDataService={clearFBDataService}
    fbDataBankOptions={fbDataBankOptions}
  />
);

export default connect(state => ({
  offices: getSelectOptions(state, 'offices'),
}))(FbDataModal);
